module.exports = __webpack_public_path__ + "img/language.e63c9306.svg";